import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IReinsurer, IReinsurerValues } from '.';

export const drawerSections = (
  value: IReinsurerValues[]
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      reinsurersRepeater: {
        name: 'reinsurersRepeater',
        title: '',
        type: FormFieldType.repeaterBox,
        addButtonText: '+Add Reinsurer',
        value: value,
        maxRepeaterLength: 999,
        minRepeaterLength: 1,
        inputs: {
          reinsurer: {
            name: 'reinsurer',
            title: 'Additional Reinsurer', // This is the default title
            dynamicTitle: ['Leader Reinsurer*'], // Dynamic title based on the index
            placeholder: 'Type to search for Reinsurer',
            type: FormFieldType.autocomplete,
            value: '',
            error: '',
            required: true,
            customValidator: (values) => {
              const reinsurerIds = values.reinsurersRepeater.map(
                (item: IReinsurer) => item.reinsurer
              );
              const isDuplicated = reinsurerIds.some(
                (id: string, index: number) =>
                  reinsurerIds.indexOf(id) !== index
              );
              return isDuplicated ? 'Reinsurer already selected' : '';
            },
          },
          share: {
            name: 'share',
            title: 'Share',
            dynamicTitle: ['Share*'],
            placeholder: 'Enter Share',
            type: FormFieldType.percentage,
            value: '',
            error: '',
            required: true,
            customValidator: (values) => {
              const totalShare = values.reinsurersRepeater.reduce(
                (acc: number, item: any) => acc + parseFloat(item.share || 0),
                0
              );

              return totalShare !== 100
                ? 'Total Share should be equal to 100%'
                : '';
            },
          },
        },
      },
    },
  },
];
